import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CustomQuickorderModule } from '../../custom-quickorder.module';

import { CustomQuickorderPageComponent } from './custom-quickorder-page.component';

const customQuickorderPageRoutes: Routes = [{ path: '', component: CustomQuickorderPageComponent }];

@NgModule({
  imports: [RouterModule.forChild(customQuickorderPageRoutes), CustomQuickorderModule],
  declarations: [CustomQuickorderPageComponent],
})
export class CustomQuickorderPageModule {}
